import { useBilling } from './BillingProvider';
import type { PlanCapabilities } from './types';

/**
 * @deprecated Use useBilling() or useCanAccess() instead
 */
export const useCurrentPlan = (): { plan: string } & PlanCapabilities => {
  const { plan, capabilities } = useBilling();

  return {
    plan,
    ...capabilities,
  };
};
